export var AccountCheckRefresh = "AccountCheckRefresh";
export var UpperSupCheckRefresh = "UpperSupCheckRefresh";
